const NAS_PORT = 9001;
const getNasBaseUrl = (nasIpAddr) => `http://${nasIpAddr}:${NAS_PORT}`;

const resolveNasResourceUrl = (url, baseUrl) => {
  if (!url) return url;

  const resourceUrl = new URL(url, `${baseUrl}/`);

  return `${baseUrl}${resourceUrl.pathname}${resourceUrl.search}${resourceUrl.hash}`;
};

export const getNasFiles = async (path, nasIpAddr) => {
  const query = new URLSearchParams({ path });
  const baseUrl = getNasBaseUrl(nasIpAddr);
  const response = await fetch(`${baseUrl}/api/files?${query}`);

  let result;
  try {
    result = await response.json();
  } catch {
    throw new Error('视频服务响应异常');
  }

  if (!response.ok || result?.error) {
    const error = new Error(result?.error || '视频目录读取失败');
    error.status = response.status;
    error.code = result?.error;
    throw error;
  }

  if (!Array.isArray(result?.items)) {
    throw new Error('视频目录数据格式异常');
  }

  return {
    ...result,
    items: result.items.map((item) =>
      item.url
        ? { ...item, url: resolveNasResourceUrl(item.url, baseUrl) }
        : item
    ),
  };
};
